import cn from "classnames"
import { useState } from "react"

import { Divider, Drawer, Flex, Text } from "@/atoms"
import { Heading } from "@/molecules/Heading"
import { getAiPolicyKind } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies.selector"
import { useAiPolicies } from "@/pages/GovernancePage/applications/policies/useAiPolicies"
import { RuleCard } from "../RuleCard"
import { RuleTitle } from "../RuleTitle"
import { TitleDrawerRule } from "./TitleDrawerRule"
import { ViolationsTable } from "./ViolationsTable"

import styles from "./RuleCardList.module.scss"

import type { RuleCardListProps } from "./RuleCardList.types"

export const RuleCardList = (props: RuleCardListProps) => {
  const { record } = props
  const { violated } = record
  const types = ["allowed", "notAllowed"] as const
  const [drawerIndex, setDrawerIndex] = useState(-1)
  const { features } = useAiPolicies()
  const kind = getAiPolicyKind(record.live)

  return (
    <Flex vertical gap={32}>
      {types.map((type) => {
        const currentType = type === "allowed" ? "allow" : "notAllow"

        return (
          <Flex vertical gap={10} key={type}>
            {Array.isArray(record[type]) &&
              record[type].map((data, index) => (
                <Flex vertical gap={10} key={index}>
                  {index === 0 && <RuleTitle type={currentType} kind={kind} />}
                  {index > 0 && (
                    <Flex align="center" gap={12}>
                      <Flex flex={1}>
                        <Divider className={styles.divider14} />
                      </Flex>
                      <Text
                        type="secondary"
                        className={cn("sm-text-ks", styles.mono)}
                      >
                        OR
                      </Text>
                      <Flex flex={1}>
                        <Divider className={styles.divider14} />
                      </Flex>
                    </Flex>
                  )}
                  <RuleCard
                    type={currentType}
                    data={data}
                    violated={violated}
                    openDrawer={() => setDrawerIndex(index)}
                  />
                  {features.violations && (
                    <Drawer
                      open={drawerIndex === index}
                      size={900}
                      title={<TitleDrawerRule record={record} />}
                      onClose={() => setDrawerIndex(-1)}
                    >
                      <Flex vertical gap={32} className={styles.drawerContent}>
                        <Flex vertical gap={12}>
                          <Heading
                            capitalize={false}
                            level={5}
                            title="Violations of AI Policy"
                          />
                          <RuleCard
                            prefix={
                              <RuleTitle type={currentType} kind={kind} />
                            }
                            mode="drawer"
                            type={currentType}
                            data={data}
                            violated={violated}
                          />
                        </Flex>
                        <ViolationsTable agentId={props.agentId} data={data} />
                      </Flex>
                    </Drawer>
                  )}
                </Flex>
              ))}
          </Flex>
        )
      })}
    </Flex>
  )
}
